/* global ga */
import types from '../actions/types'

const nonInteraction = true

export default (store) => (next) => (action) => {
	switch (action.type) {
		case types.USER_UPDATED:
			if (action.payload) {
				ga('set', 'userId', action.payload.key)
			}
			break
		case types.POLL_CREATE:
			ga('send', 'event', 'Poll', 'Created')
			break
		case types.POLL_REMOVE:
			ga('send', 'event', 'Poll', 'Removed')
			break
		case types.VOTE_CAST:
			ga('send', 'event', 'Vote', 'Cast')
			break
		default:
			break
	}

	return next(action)
}



// WEBPACK FOOTER //
// ./src/redux/middleware/analytics.js